<script>
  import { ScreenUsers, Group, Person } from "../../../Components/Icons";
  import { getLinks } from "../../Api/congress_stores.js";
  import { Modal, Button } from "../../../Components";
  import PortraitPopup from "../../Component/PortraitPopup.svelte";

  export let item;
  export let selectedValueAusstellerId;
  export let large = false;

  let showModal = false;

  function handleModalOpenClick() {
    showModal = true;
  }

  const workshopLink = getLinks("workshop");
</script>

{#if selectedValueAusstellerId > 0 ? selectedValueAusstellerId == item.ausstellerId : true}
  {#if large}
    <div class="mb-8" id="sponsorBlk_{item.ausstellerId}">
      <h3 class="mb-2 bg-theme-minor-50 px-3 py-1 text-lg font-bold text-theme-minor-800">
        {item.firmenname_IMK_AV}
      </h3>
      <div class="flex flex-col gap-4 sm:grid sm:grid-cols-3">
        {#if item.imk_logo_online_filename}
          <figure>
            <img class="h-auto max-w-full" src="//www.institutional-money.com/content/kgv/bilder/{item.imk_logo_online_filename}" alt={item.firmenname_IMK_AV} />
          </figure>
        {:else}
          <div aria-hidden="true" />
        {/if}
        <div>
          <p class="mb-2">
            {#if item.av_telefon != ""}
              <span class="block">Tel.: {item.av_telefon}</span>
            {/if}
            {#if item.av_fax != "" && item.av_fax != "//"}
              <span class="block">Fax: {item.av_fax}</span>
            {/if}
          </p>
          <Button minor on:click={handleModalOpenClick} class="text-sm">Info & Porträt</Button>
        </div>
        <div class="flex flex-col gap-2">
          {#if item.WSLinkVID > 0}
            <a class="flex justify-start gap-1 font-bold text-theme-minor-800 hocus:text-theme-minor-900" href="{workshopLink}?gt=1&amp;vid={item.WSLinkVID}&amp;gid={item.ausstellerId}">
              <ScreenUsers class="h-4 w-6 text-theme-signal" />
              <span>Workshop</span>
            </a>
          {:else}
            <span class="flex justify-start gap-1 opacity-40">
              <ScreenUsers class="h-4 w-6" />
              <span>Workshop</span>
            </span>
          {/if}
          {#if item.GGLinkVID > 0}
            <a class="flex justify-start gap-1 font-bold text-theme-minor-800 hocus:text-theme-minor-900" href="{workshopLink}?gt=2&amp;vid={item.GGLinkVID}&amp;gid={item.ausstellerId}">
              <Group class="h-4 w-6 text-theme-signal" />
              <span>Gruppengespräch</span>
            </a>
          {:else}
            <span class="flex justify-start gap-1 opacity-40">
              <Group class="h-4 w-6" />
              <span>Gruppengespräch</span>
            </span>
          {/if}
          {#if item.O2OLinkVID > 0}
            <a class="flex justify-start gap-1 font-bold text-theme-minor-800 hocus:text-theme-minor-900" href="{workshopLink}?gt=3&amp;gid={item.ausstellerId}">
              <Person class="h-4 w-6 text-theme-signal" />
              <span>One to One</span>
            </a>
          {:else}
            <span class="flex justify-start gap-1 opacity-40">
              <Person class="h-4 w-6" />
              <span>One to One</span>
            </span>
          {/if}
        </div>
      </div>
    </div>
  {:else}
    <div class="flex flex-col items-center gap-1 bg-white p-1 text-sm" id="sponsorBlk_{item.ausstellerId}">
      {#if item.imk_logo_online_filename}
        <img src="//www.institutional-money.com/content/kgv/bilder/{item.imk_logo_online_filename}" width="150" height="70" alt={item.firmenname_IMK_AV} />
      {:else}
        <strong class="flex flex-1 items-center justify-center">{item.firmenname_IMK_AV}</strong>
      {/if}
      <Button link on:click={handleModalOpenClick}>Kontaktinformation</Button>
      <div class="mt-2 flex items-center gap-3">
        {#if item.WSLinkVID > 0}
          <a class="text-theme-signal" title="Workshop" href="{workshopLink}?gt=1&amp;vid={item.WSLinkVID}&amp;gid={item.ausstellerId}">
            <ScreenUsers class="h-4" />
          </a>
        {:else}
          <span title="Kein Workshop" class="opacity-40"><ScreenUsers class="h-4" /></span>
        {/if}

        {#if item.GGLinkVID > 0}
          <a title="Gruppengespräch" class="text-theme-signal" href="{workshopLink}?gt=2&amp;vid={item.GGLinkVID}&amp;gid={item.ausstellerId}">
            <Group class="h-4 " />
          </a>
        {:else}
          <span title="Kein Gruppengespräch" class="opacity-40">
            <Group class="h-4" />
          </span>
        {/if}

        {#if item.O2OLinkVID > 0}
          <a title="One to One Gespräch" class="text-theme-signal" href="{workshopLink}?gt=3&amp;gid={item.ausstellerId}">
            <Person class="h-4" />
          </a>
        {:else}
          <span title="Kein One to One Gespräch" class="opacity-40">
            <Person class="h-4" />
          </span>
        {/if}
      </div>
      <div id="sponsor{item.ausstellerId}" class="modalWindow sponsorModalWindow">
        {item.detailcontent}
      </div>
    </div>
  {/if}

  <Modal bind:showModal><PortraitPopup {item} /></Modal>
{/if}
